import { render, staticRenderFns } from "./BatchSetDepot.vue?vue&type=template&id=54ab67bc&scoped=true"
import script from "./BatchSetDepot.vue?vue&type=script&lang=js"
export * from "./BatchSetDepot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab67bc",
  null
  
)

export default component.exports